import { getDiaryCoverPreset } from '../../utils/photoCardDiaryCoverStorage';
import './DiaryBookCover.css';

const DEFAULT_COVER_SUBTITLE = 'My collected photo cards';
const DEFAULT_COVER_BADGE = 'Collector Edition';

export default function DiaryBookCover({
  cover,
  title,
  memberName,
  subtitle,
  ribbonText,
  badgeText,
  showBadge = true,
  className = '',
  style
}) {
  const preset = getDiaryCoverPreset(cover?.colorId);
  const resolvedTitle = title ?? cover?.title ?? '';
  const resolvedSubtitle = subtitle ?? memberName ?? DEFAULT_COVER_SUBTITLE;
  const resolvedBadge = badgeText ?? DEFAULT_COVER_BADGE;

  return (
    <div
      className={`diary-book-cover-theme ${className}`.trim()}
      style={{
        '--diary-cover-color': preset.coverColor,
        '--diary-cover-text': preset.textColor,
        '--diary-page-color': preset.pageColor,
        '--diary-page-edge-color': preset.pageEdgeColor,
        '--diary-accent-color': preset.accentColor,
        ...style
      }}
    >
      <div className="diary-book-cover-panel">
        {ribbonText
          ? <div className="diary-book-cover-ribbon">
              <div className="diary-book-cover-ribbon-text">{ribbonText}</div>
            </div>
          : null}
        <div className="diary-book-cover-copy">
          <div className="diary-book-cover-subtitle">{resolvedSubtitle}</div>
          <div className="diary-book-cover-title">{resolvedTitle}</div>
        </div>
        {showBadge ? <div className="diary-book-cover-badge">{resolvedBadge}</div> : null}
      </div>
    </div>
  );
}
